import React from 'react';

const Footer = (): JSX.Element => {
  const year = new Date().getFullYear();

  return (
    <footer className="xl:absolute xl:bottom-0 text-xs p-2 text-right w-full bg-sky-50 border-t border-sky-800">
      <span dangerouslySetInnerHTML={{ __html: '&copy;' }} />
      <a href="https://tublitzed.com/" className="link" target="_blank">
        InMySpareTime
      </a>
      , {year}.
    </footer>
  );
};

export default Footer;
